<template>
  <div class="information-page">
    <header class="information-header">
      <button
        class="back-button"
        type="button"
        :aria-label="$t('notice.back')"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('notice.information') }}</h1>
      <span aria-hidden="true" />
    </header>

    <div
      class="information-tabs"
      role="tablist"
    >
     
      <button
        class="information-tab"
        :class="{ 'information-tab--active': activeTab === 'member' }"
        type="button"
        role="tab"
        :aria-selected="activeTab === 'member'"
        @click="activeTab = 'member'"
      >
        {{ $t('notice.memberInformation') }}
      </button>
	  <button
	    class="information-tab"
	    :class="{ 'information-tab--active': activeTab === 'system' }"
	    type="button"
	    role="tab"
	    :aria-selected="activeTab === 'system'"
	    @click="activeTab = 'system'"
	  >
	    {{ $t('notice.systemInformation') }}
	  </button>
    </div>

    <main
      class="information-list"
      role="tabpanel"
    >
      <van-loading
        v-if="loading"
        class="information-status"
        size="24px"
      />
      <div
        v-else-if="loadFailed"
        class="information-status"
      >
        <p>{{ $t('notice.loadFailed') }}</p>
        <button
          type="button"
          @click="loadInformation"
        >
          {{ $t('notice.retry') }}
        </button>
      </div>
      <van-empty
        v-else-if="!activeItems.length"
        :description="emptyText"
      />
      <article
        v-for="item in activeItems"
        v-else
        :key="activeTab + '-' + item.id"
        class="information-item"
      >
        <h2>{{ item.title }}</h2>
        <p class="information-item__content">
          {{ item.content }}
        </p>
        <time>{{ formatDate(item.published_at) }}</time>
      </article>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import { Empty, Icon, Loading } from 'vant';
import Fetch from '../../utils/fetch';

Vue.use(Empty).use(Icon).use(Loading);

export default {
  name: 'Notice',
  data() {
    return {
      activeTab: 'member',
      loading: true,
      loadFailed: false,
      systemNotices: [],
      memberMessages: []
    };
  },
  computed: {
    activeItems() {
      return this.activeTab === 'system' ? this.systemNotices : this.memberMessages;
    },
    emptyText() {
      return this.activeTab === 'system'
        ? this.$t('notice.emptySystemInformation')
        : this.$t('notice.emptyMemberInformation');
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.loadInformation();
  },
  methods: {
    loadInformation() {
      this.loading = true;
      this.loadFailed = false;
      Fetch('/user/information').then((response) => {
        const data = response.data || {};
        this.systemNotices = Array.isArray(data.system_notices) ? data.system_notices : [];
        this.memberMessages = Array.isArray(data.member_messages) ? data.member_messages : [];
      }).catch(() => {
        this.loadFailed = true;
      }).finally(() => {
        this.loading = false;
      });
    },
    formatDate(value) {
      return typeof value === 'string' ? value.slice(0, 10) : '';
    }
  }
};
</script>

<style lang="less" scoped>
.information-page {
  min-height: 100vh;
  padding-bottom: 76px;
  background: #fff;
  box-sizing: border-box;
}

.information-header {
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  align-items: center;
  height: 62px;
}

.information-header h1 {
  margin: 0;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
}

.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #555;
  font-size: 14px;
}

/deep/ .back-button .van-icon {
  font-size: 14px;
}

.information-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0 24px;
}

.information-tab {
  position: relative;
  min-height: 46px;
  padding: 0 4px;
  border: 0;
  background: transparent;
  color: #000;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
}

.information-tab--active {
  color: #ff3d79;
}

.information-tab--active::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 1px;
  background: #ff3d79;
  content: '';
}

.information-list {
  min-height: 160px;
}

.information-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  color: #777;
  font-size: 12px;
}

.information-status p {
  margin: 0 0 12px;
}

.information-status button {
  min-width: 72px;
  padding: 8px 12px;
  border: 0;
  border-radius: 4px;
  background: #ff3d79;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
}

.information-item {
  padding: 16px 24px 10px;
  border-bottom: 1px solid #eee;
}

.information-item h2 {
  margin: 0;
  color: #102139;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.information-item__content {
  margin: 14px 0 12px;
  color: #102139;
  font-size: 12px;
  line-height: 16px;
  white-space: pre-line;
  word-break: normal;
  overflow-wrap: normal;
}

.information-item time {
  display: block;
  color: #596579;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
}

.information-page {
  padding: 12px 18px 78px;
  background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
}

.information-header {
  height: 30px;
}

.information-header h1 {
  color: #111;
  font-size: 14px;
  font-weight: 600;
}

.back-button {
  width: 24px;
  height: 24px;
  color: #111;
}

.information-tabs {
  margin-top: 12px;
  padding: 0 10px;
  border-radius: 10px 10px 0 0;
  background: #fff;
}

.information-tab {
  min-height: 42px;
  color: #5e5665;
  font-size: 12px;
}

.information-tab--active {
  color: #f8328c;
}

.information-tab--active::after {
  height: 2px;
  background: #f8328c;
}

.information-list {
  min-height: 180px;
  padding: 0 14px;
  border-radius: 0 0 10px 10px;
  background: #fff;
}

.information-item {
  padding: 14px 0 10px;
  border-color: #f0eaf1;
}

.information-item h2 {
  color: #2d2433;
  font-size: 14px;
  font-weight: 600;
}

.information-item__content {
  margin: 8px 0;
  color: #5e5665;
  font-size: 12px;
  line-height: 18px;
}

.information-item time {
  color: #9b8d9d;
  font-size: 10px;
}

.information-status button {
  border-radius: 16px;
  background: linear-gradient(100deg, #df4ab7 0%, #6d3bc4 100%);
  font-size: 12px;
}
</style>
